
import ContentComponent from './contentComponent';
import EventListItem from './eventListItem';
import Banner from './banner';
import DeleteModal from './deleteModal';
import HorizontalTab from './horizontal-tab/horizontal-tab';
import Label from './label';
import Avatar from './avatar';
export {
  ContentComponent,
  EventListItem,
  Banner,
  DeleteModal,
  HorizontalTab,
  Label,
  Avatar,
};